import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false }) => (
  <div className={`flex items-center gap-3 text-xs uppercase tracking-[0.28em] ${dark ? "text-icdh-white/60" : "text-icdh-red"}`}>
    <span className="h-px w-8 bg-icdh-red" />
    {children}
  </div>
);
